function getCookie(name) {
    let tokena = localStorage.getItem("misUserData");
    tokena = tokena ? JSON.parse(tokena) : null;
    return tokena?.misUserData?.token;
}

export default getCookie;